




















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from 'moment';
import { isAI, isCooperate, isTelBooking } from "@/libs/utils";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;
  @Prop() refresh!:any;

  ai_status = false;
  ai_status_ext = false;
  order_status = false;
  is_limit_ai = false;
  is_limit_ai_sale = false;
  phone_status = false;

  ai_online_time='';

  order_online_time='';

  async mounted() {
    const res = await this.$store.dispatch("enterapply/detail", {
      stadium_id: this.stadiumId,
    });
    console.log('data:',res,!!(+res.X))
    if (res && res.Data && res.Data !== "{}") {
      const obj: any = res.Data;
      // console.log(res.Data);
      this.ai_status = !!(obj.online_status & 8);
      this.order_status = !!(obj.online_status & 4);
      this.phone_status = !!(obj.online_status & 2);
      this.ai_online_time = obj.ai_online_time;
      this.order_online_time=obj.order_online_time;
      if(this.ai_status){
        this.ai_status_ext= (+obj.is_limit_ai)==1;
        this.ai_status=!this.ai_status_ext;
      } else {
        this.is_limit_ai= (+obj.is_limit_ai)==1;
        this.is_limit_ai_sale= (+obj.is_limit_ai)==2;
      }
    }
    console.log('order:',this.order_status,this.is_limit_ai)
  }

  changeOnlineStatus(item: string, val: boolean) {
    switch (item) {
      case "ai":
        this.showTsConfirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}智能场馆？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/aiOnline", { id: this.stadiumId });
              this.ai_status_ext=false;
            } else {
              this.$store.dispatch("stadium/aiOffline", {
                id: this.stadiumId,
              });
            }
            this.$message.success("操作成功");
            this.ai_status = val;
          },
          onCancel: () => {
            // this.ai_status = val ? false : val;
          },
        });
        break;
      case "ai_ext":
        this.showTsConfirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}智能场馆(简易版)？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/aiOnline", { id: this.stadiumId,limit:1 });
              this.ai_status=false;
            } else {
              this.$store.dispatch("stadium/aiOffline", {
                id: this.stadiumId,
              });
            }
            this.$message.success("操作成功");
            this.ai_status_ext = val;
          },
          onCancel: () => {
            // this.ai_status = val ? false : val;
          },
        });
        break;
      case "order":
        this.showTsConfirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}订场平台？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/orderOnline", {
                id: this.stadiumId,
              });
              this.ai_status=false;
              this.ai_status_ext=false;
            } else {
              this.$store.dispatch("stadium/orderOffline", {
                id: this.stadiumId,
              });
            }
            this.$message.success("操作成功");
            this.order_status = val;
            this.is_limit_ai=false;
            this.is_limit_ai_sale=false;
          },
          onCancel: () => {
            // this.order_status = val ? false : val;
          },
        });
        break;
      case "phone":
        this.showTsConfirm({
          title: "确认信息",
          content: `确定要${val ? "上线" : "下线"}电话订场？`,
          onOk: () => {
            if (val) {
              this.$store.dispatch("stadium/phoneOnline", {
                id: this.stadiumId,
              });
            } else {
              this.$store.dispatch("stadium/phoneOffline", {
                id: this.stadiumId,
              });
            }
            this.$message.success("操作成功");
            this.phone_status = val;
          },
          onCancel: () => {
            // this.phone_status = val ? false : val;
          },
        });
        break;
      case "orderai":
        this.showTsConfirm({
            title: "确认信息",
            content: `确定要${val ? "上线" : "下线"}智能馆？`,
            onOk: () => {
              if (val) {
                this.$store.dispatch("stadium/orderOnline", {
                  id: this.stadiumId,
                  limit:1,
                }).then(()=>{
                  if(this.refresh){
                    this.refresh()
                  }
                });
                this.ai_status=false;
                this.ai_status_ext=false;
              } else {
                this.$store.dispatch("stadium/orderOffline", {
                  id: this.stadiumId,
                  limit:1,
                });
              }
              this.$message.success("操作成功");
              this.order_status=val;
              this.is_limit_ai = val;
              this.is_limit_ai_sale=false;
            },
            onCancel: () => {
              // this.order_status = val ? false : val;
            },
        });
        break;
      case "orderai_sale":
        this.showTsConfirm({
            title: "确认信息",
            content: `确定要${val ? "上线" : "下线"}智能馆（销售版）？`,
            onOk: () => {
              if (val) {
                this.$store.dispatch("stadium/orderOnline", {
                  id: this.stadiumId,
                  limit:2,
                }).then(()=>{
                  if(this.refresh){
                    this.refresh()
                  }
                });
                this.ai_status=false;
                this.ai_status_ext=false;
              } else {
                this.$store.dispatch("stadium/orderOffline", {
                  id: this.stadiumId,
                  limit:2,
                });
              }
              this.$message.success("操作成功");
              this.order_status=val;
              this.is_limit_ai_sale = val;
              this.is_limit_ai=false;
            },
            onCancel: () => {
              // this.order_status = val ? false : val;
            },
        });
        break;
    }
  }

  aiOnlineNotice() {
    this.$confirm({
      title: "确认消息",
      content: "确定要发送ai馆上线通知吗？",
      onOk: async () => {
        // this.$Message.info('Clicked ok');
        const res = await this.$store.dispatch("stadium/aiOnlineNotice", {
          id: this.stadiumId,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      },
      onCancel: () => {
        // this.$Message.info('Clicked cancel');
      },
    });
  }

  orderOnlineNotice() {
    this.$confirm({
      title: "确认消息",
      content: "确定要发送订场平台上线通知吗？",
      onOk: async () => {
        // this.$Message.info('Clicked ok');
        const res = await this.$store.dispatch("stadium/orderOnlineNotice", {
          id: this.stadiumId,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("通知成功");
        } else {
          this.$message.error("通知失败");
        }
      },
      onCancel: () => {
        // this.$Message.info('Clicked cancel');
      },
    });
  }

  updateAiOnlineTime() {
    let v=this.ai_online_time || '';
    if(v) {
      v=moment(String(v)).format('YYYY-MM-DD')
    }
    this.$confirm({
      title: '确认消息',
      content: '确定更新24小时AI场馆上线时间吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/updateAiOnLineTime', {
          id: this.stadiumId,
          is_update:1,
          ai_on_line_time: v,
        });
        if (res && res.Code==200) {
          this.$message.success('更新成功');
        } else {
          this.$message.error('更新失败');
        }
      },
    });
  }

  updateOrderOnlineTime() {
    let v=this.order_online_time || '';
    if(v) {
      v=moment(String(v)).format('YYYY-MM-DD')
    }
    this.$confirm({
      title: '确认消息',
      content: '确定更新AI场馆上线时间吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/updateAiOnLineTime', {
          id: this.stadiumId,
          is_update:2,
          ai_on_line_time: v,
          is_order:1,
        });
        if (res && res.Code==200) {
          this.$message.success('更新成功');
        } else {
          this.$message.error('更新失败');
        }
      },
    });
  }

}
